module.exports = __webpack_public_path__ + "static/media/spotify.3b852ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spotify/spotify.jpg
// module id = 148
// module chunks = 0